module.exports = new __parcel__URL__("pureCSS.d8afb112.svg").toString();